export default __webpack_public_path__ + "static/media/illustration-wave.5e6fefdd.svg";